import React from 'react'
import { withRouter } from 'react-router-dom'
import { number as numberFormatter, date as dateFormatter, formatIn } from 'loankeeper-common/helpers/formatters'
import { colors } from 'shared'
//@ts-ignore
import LKGrid from 'shared/LKGrid'
//@ts-ignore
import withConstantPermissions from 'shared/containers/withConstantPermissions'
import { translateCmd, translateBase, icon } from '../helpers'
import { formName } from '../constants'
import { constants as DCConstants } from '../../DetailsContainer'
import { ApplicationsTabPropTypes } from '../types'
const config = {
  gridIdentity: {
    formName,
    objectName: 'dbgrd_app',
  },

  enableColumnsResize: true,
  enableColumnsOrder: true,

  syncGridState: true,
  enableRowSelection: true,

  getRowStyle: ({
    node: {
      data: { StateID, AppScreening },
    },
  }) => {
    if (StateID === 1 && AppScreening === 1) {
      return { color: colors.pink }
    }
    if (StateID === 2) {
      return { backgroundColor: colors.green }
    }
    if (StateID === 3) {
      return { backgroundColor: colors.red }
    }
    if (StateID === 5) {
      return { backgroundColor: colors.yellow }
    }
    return {}
  },

  columnConfigs: {
    IsAppExpired: {
      iconComponent: (value: number) => (value === 1 ? 'clock' : null),
    },
    IsAppDisbursed: {
      iconComponent: (value: number) => (value === 1 ? 'loan' : null),
    },
    RegDate: {
      valueFormatter: formatIn('value', dateFormatter),
    },
    ReqAmount: {
      valueFormatter: formatIn('value', numberFormatter),
      cellStyle: { textAlign: 'right' },
    },
    TermMonths: {
      cellStyle: { textAlign: 'right' },
    },
  },
}

@withRouter
@withConstantPermissions()
class Applications extends React.Component<ApplicationsTabPropTypes> {
  onRowDoubleClicked = ({ node: { data } }) => {
    if (this.props.permissions.VIEW_APPLICATION) {
      this.pushDetailsRoute(data)
    }
  }

  pushDetailsRoute = ({ ID, HashSum_AppID_, StateID, AppScreening }) => {
    let url = `/secure/application/${ID}/details/${HashSum_AppID_}`

    if (StateID === 1 && AppScreening === 1) {
      url = `${url}/screening`
    }

    this.props.history.push(url)
  }

  getContextMenuItems = (params) => {
    const {
      node: { data },
    } = params
    if (this.props.permissions.VIEW_APPLICATION) {
      return [
        {
          name: translateCmd('view_application'),
          action: () => this.pushDetailsRoute(data),
          icon: 'info',
        },
      ]
    }
  }

  render() {
    const { data, ID } = this.props

    return (
      <div className="u-fluid u-relative">
        <LKGrid
          rowData={data}
          onRowDoubleClicked={this.onRowDoubleClicked}
          getContextMenuItems={this.getContextMenuItems}
          {...config}
          instanceName={`${DCConstants.DetailsGridPrefixes.client}-${ID}-Applications`}
        />
      </div>
    )
  }
}

//@ts-ignore
Applications.config = {
  title: () => translateBase('tb_applications'),
  name: 'applications',
  component: Applications,
  api: 'apps',
  icon: icon('tb_applications'),
}
//@ts-ignore
Applications.defaultProps = {
  data: [],
}

export default Applications
